const useChainStoreShortcut = (props) => {
  const { COLUMN_COUNT, moveToIdCB } = props;
  function handleKeyPress(event) {
    if (event.key === "Enter") {
      //Right Enter. TODO : Use Right Enter
      if (event.location === 3) {
        event.preventDefault();
        focusNavigation(event.target, event.shiftKey);
      }
      //Left Enter + Shift
      else if (event.location === 0 && !event.shiftKey) {
        event.preventDefault();
        let firstSalesResult = document.getElementById(`productItem-0-0`);
        if (firstSalesResult) firstSalesResult.focus();
      } else if (event.location === 0 && event.shiftKey) {
        event.preventDefault();
        let firstHeader = document.getElementById(`header-0`);
        if (firstHeader) firstHeader.focus();
      }
    }
  }

  function handleKeyDown(event) {
    //Arrow Handle
    const keyCode = event.keyCode;
    //Arrow Key
    if (keyCode === 37) {
      event.preventDefault();
      // Handle left arrow key press
      focusNavigation(event.target, true);
    } else if (keyCode === 39) {
      event.preventDefault();
      // Handle right arrow key press
      focusNavigation(event.target, false);
    } else if (keyCode === 38) {
      event.preventDefault();
      // Handle up arrow key press
      const focusingItem = document.activeElement.id;
      const currentRow = parseInt(focusingItem.split("-")[1]);
      const currentColumn = parseInt(focusingItem.split("-")[2]);
      if (currentRow === 0) moveToElement("header");
      else moveToElement("productItem", currentRow - 1, currentColumn);
    } else if (keyCode === 40) {
      event.preventDefault();
      // Handle down arrow key press
      const focusingItem = document.activeElement.id;
      const currentRow = parseInt(focusingItem.split("-")[1]);
      const currentColumn = parseInt(focusingItem.split("-")[2]);
      moveToElement("productItem", currentRow + 1, currentColumn);
    }
  }

  function focusNavigation(currentElement, isPrevious = false) {
    const focusing = currentElement.id || document.activeElement.id;
    const step = isPrevious ? -1 : 1;
    const currentColumn = parseInt(focusing.split("-")[2], 10);
    const currentRow = parseInt(focusing.split("-")[1], 10);
    let nextColumn = currentColumn + step;
    let nextRow = currentRow;
    let district = "productItem";

    // 次の列
    if (isPrevious) {
      if (nextColumn < 0) nextColumn = COLUMN_COUNT - 1;
      if (currentColumn === 0) {
        if (currentRow === 0) {
          district = "header";
        } else {
          nextRow = currentRow - 1;
        }
      }
    } else {
      if (nextColumn === COLUMN_COUNT) {
        nextColumn = 0;
        nextRow = currentRow + 1;
      }
    }
    moveToElement(district, nextRow, nextColumn);
  }

  function moveToElement(district, row = 0, column = 0) {
    setTimeout(() => {
      const id =
        district !== "header" ? `${district}-${row}-${column}` : `header-4`;
      moveToIdCB(id);
      const element = document.getElementById(id);
      if (element) {
        element.focus();
      } else {
      }
    }, 0);
  }

  return {
    handleKeyDown,
    handleKeyPress,
    focusNavigation,
  };
};
export default useChainStoreShortcut;
